import {
  ArrangementResource,
  Resource,
  ResourceIdentifierWithType,
} from '@thiememeulenhoff/types';

export function flattenResources<T extends ArrangementResource | Resource>(
  resources: Array<T>,
  parents: Array<ResourceIdentifierWithType> = [],
): Array<T> {
  const entities: Array<T> = [];

  resources.forEach((resource) => {
    const parent = parents.at(-1);
    const children = resource.children || [];
    const copy = {
      ...resource,
      parents,
      ...(parent ? { parentIdentifier: parent.contentIdentifier } : {}),
    } as T;

    entities.push(
      copy,
      ...flattenResources(children as Array<T>, [
        ...parents,
        {
          contentIdentifier: resource.contentIdentifier,
          digitalResourceType: resource.digitalResourceType,
        },
      ]),
    );
  });

  return entities;
}
